"use strict";

var _Object$defineProperty = require("@babel/runtime-corejs3/core-js-stable/object/define-property");

_Object$defineProperty(exports, "__esModule", {
  value: true
});

exports.default = void 0;
var regionRole = {
  abstract: false,
  accessibleNameRequired: true,
  baseConcepts: [],
  childrenPresentational: false,
  nameFrom: ['author'],
  props: {},
  relatedConcepts: [{
    module: 'HTML',
    concept: {
      name: 'frame'
    }
  }, {
    concept: {
      name: 'Device Independence Glossart perceivable unit'
    }
  }, {
    module: 'HTML',
    concept: {
      name: 'section',
      attributes: [{
        name: 'aria-label',
        constraints: ['set']
      }]
    }
  }, {
    module: 'HTML',
    concept: {
      name: 'section',
      attributes: [{
        name: 'aria-labelledby',
        constraints: ['set']
      }]
    }
  }],
  requireContextRole: [],
  requiredContextRole: [],
  requiredOwnedElements: [],
  requiredProps: {},
  superClass: [['roletype', 'structure', 'section', 'landmark']]
};
var _default = regionRole;
exports.default = _default;